import { render, staticRenderFns } from "./Explicit.vue?vue&type=template&id=5b927eab&scoped=true&"
import script from "./Explicit.vue?vue&type=script&lang=js&"
export * from "./Explicit.vue?vue&type=script&lang=js&"
import style0 from "./Explicit.vue?vue&type=style&index=0&id=5b927eab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b927eab",
  null
  
)

export default component.exports